import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WidgetSectionTitle = ({
  title,
  subtitle,
  icon,
  transform,
  className,
  titleStyle,
  subtitleStyle,
}) => {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        minWidth: 0,
      }}
    >
      <span
        className="d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
        style={{
          width: 40,
          height: 40,
          background: "rgba(13, 110, 253, 0.08)",
          color: "#2563eb",
        }}
      >
        {React.isValidElement(icon) ? (
          icon
        ) : (
          <FontAwesomeIcon icon={icon} transform={transform} />
        )}
      </span>

      <div style={{ minWidth: 0, flex: 1 }}>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <h4
            className="mb-0 text-1100 fw-bold"
            style={{
              fontSize: 18,
              lineHeight: 1.2,
              letterSpacing: 0,
              ...titleStyle,
            }}
          >
            {title}
          </h4>
          <span
            aria-hidden="true"
            style={{
              width: 6,
              height: 6,
              borderRadius: 999,
              background: "#cbd5e1",
              flexShrink: 0,
            }}
          />
        </div>

        {subtitle && (
          <p
            className="mb-0 text-700"
            style={{
              marginTop: 4,
              fontSize: 12.5,
              lineHeight: 1.55,
              maxWidth: 760,
              ...subtitleStyle,
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

WidgetSectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,
  transform: PropTypes.string,
  className: PropTypes.string,
  titleStyle: PropTypes.object,
  subtitleStyle: PropTypes.object,
};

export default WidgetSectionTitle;
